export default __webpack_public_path__ + "static/media/framework.0871821e.svg";